import { PaycodeDistribution, PaycodeDistributionCreate } from "./@types/PaycodeDistributionModel";

export class PaycodesDistributionsRepository {
    private httpService: IHttpService
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getPaycodeDistributions(): Promise<PaycodeDistribution[]> {
        try {
            const response = await this.httpService.get<TKResponse<PaycodeDistribution[]>>('/paycodes_distributions');
            return response.data.sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
        } catch (error) {
            console.error('Error al obtener los paycode distributions:', error);
            throw error;
        }
    }

    async getPaycodeDistributionById(id: number): Promise<PaycodeDistribution>{
        try {
            const response = await this.httpService.get<TKResponse<PaycodeDistribution>>(`/paycodes_distributions/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error al obtener el paycode distribution con ID ${id}:`, error);
            throw error;
        }
    }

    async create(data: PaycodeDistributionCreate): Promise<PaycodeDistribution> {
        try {
            const response = await this.httpService.post<TKResponse<PaycodeDistribution>, PaycodeDistributionCreate>('/paycodes_distributions', { data });
            return response.data;
        } catch (error) {
            console.error('Error al crear el paycode distribution:', error);
            throw error;
        }
    }
    async update(id: number, data: PaycodeDistributionCreate): Promise<PaycodeDistribution> {
        try {
            const response = await this.httpService.put<TKResponse<PaycodeDistribution>, PaycodeDistributionCreate>(`/paycodes_distributions/${id}`, { data });
            return response.data;
        } catch (error) {
            console.error(`Error al actualizar el paycode distribution con ID ${id}:`, error);
            throw error;
        }
    }
    async delete(id: number): Promise<void> {
        try {
            await this.httpService.delete<void>(`/paycodes_distributions/${id}`);
        } catch (error) {
            console.error(`Error al eliminar el paycode distribution con ID ${id}:`, error);
            throw error;
        }
    }
}